t = require('views/internal/teacup-with-helpers')('header_logo')

module.exports = ->
  t.a '.header-logo.js-home-via-logo', { href: '/', 'aria-label': t.l('trello-home') }, ->
    t.span '.header-logo-loading'
    t.span '.header-logo-default'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_logo.coffee